import offerSfogliatoreData from '../../data/sfogliatore.json';
import offerCartaData from '../../data/carta.json';
import offerOnlineData from '../../data/online.json';
import offerCartaDataIG from '../../data/carta-ilgiorno.json';
import {
  getTestata,
  filterOffersByCodeName,
  transformOnlineStripeOffers,
  getAndSanitizeQS,
  goToHref,
} from '../../lib/utils';
import { trackAndRunJS } from '../Tracking/dataLayerEvents';
import { TESTATE } from '../../lib/constants';

function getCartaURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseCarta);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getSfogliatoreURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseSfogliatore);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getCheckoutURL(params) {
  const searchParams = new URLSearchParams(params);
  searchParams.append('page', 'checkout');
  return `/paywall?${searchParams.toString()}`;
}

export async function getOnlineOffers(goToURLParams, brief) {
  const offerOnline = filterOffersByCodeName(
    offerOnlineData,
    getAndSanitizeQS('online'),
  );
  const userInfo = await window.authSession;
  const trackAndGo = (offer) => {
    return trackAndRunJS(
      () => { window.tp.offer.show({ offerId: offer.offerId, termId: offer.termId }) },
      userInfo,
      offerOnline,
    );
  }
  return [
    { ...offerOnline, goTo: (offer) => { return trackAndGo(offer) } }
  ];
}

export async function getDigitalOffers(goToURLParams, brief) {
  const offerSfogliatore = filterOffersByCodeName(
    offerSfogliatoreData,
    getAndSanitizeQS('sfogliatore'),
  );
  const goToSfogliatore = goToHref(getSfogliatoreURL(goToURLParams));
  return [
    { ...offerSfogliatore, goTo: (offer) => { return goToSfogliatore } },
  ];
}

export async function getBriefOffers(offersFromUC, goToURLParams) {
  const offerOnline = filterOffersByCodeName(
    transformOnlineStripeOffers(offersFromUC, true),
    getAndSanitizeQS('online'),
  );
  const goToOnlineOffer = goToHref(getCheckoutURL(goToURLParams));
  return [{ ...offerOnline, goTo: goToOnlineOffer }];
}

export async function getAllOffers(goToURLParams, brief) {
  const onlineOffers = await getOnlineOffers(goToURLParams, brief);
  const digitalOffers = await getDigitalOffers(goToURLParams, brief);
  const offerCarta = getTestata() === 'ilgiorno' ? offerCartaDataIG : offerCartaData;
  return [...onlineOffers, ...digitalOffers, { ...offerCarta, goTo: (offer) => { return goToHref(getCartaURL(goToURLParams)) } }];
}
